module.exports = __webpack_public_path__ + "img/ico-quote.4ce55f6.svg";